import Vue from "vue";

// 注册组件
import {
  Checkbox,
  CheckboxGroup,
  Empty,
  NoticeBar,
  Popup,
  Overlay,
  button,
  Tabbar,
  TabbarItem,
  Image as VanImage,
  Col,
  Row,
  Icon,
  NavBar,
  SwipeCell,
  Card,
  List,
  Cell,
  Search,
  Sidebar,
  SidebarItem,
  TreeSelect,
  Lazyload,
  Tag,
  Divider,
  Toast,
  Form,
  field,
  Area,
  ActionSheet,
  Switch,
  Dialog,
  ContactList,
  RadioGroup,
  Radio,
  Progress,
  Swipe,
  SwipeItem,
  ShareSheet,
  Tabs,
  Tab,
  ImagePreview,
  DatetimePicker,
  Stepper,
  Picker
} from "vant";

// 使用组件
Vue.use(button)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Empty)
  .use(NoticeBar)
  .use(Picker)
  .use(Popup)
  .use(Overlay)
  .use(Tabbar)
  .use(TabbarItem)
  .use(VanImage)
  .use(Col)
  .use(Row)
  .use(Icon)
  .use(NavBar)
  .use(SwipeCell)
  .use(Card)
  .use(List)
  .use(Cell)
  .use(Search)
  .use(Sidebar)
  .use(SidebarItem)
  .use(TreeSelect)
  .use(Lazyload)
  .use(Tag)
  .use(Divider)
  .use(Toast)
  .use(Form)
  .use(field)
  .use(Area)
  .use(ActionSheet)
  .use(Switch)
  .use(Dialog)
  .use(ContactList)
  .use(RadioGroup)
  .use(Radio)
  .use(Progress)
  .use(Swipe)
  .use(SwipeItem)
  .use(ShareSheet)
  .use(Tab)
  .use(Tabs)
  .use(ImagePreview)
  .use(DatetimePicker)
  .use(Stepper);
